import React, { useState } from 'react';
import { connect } from "react-redux";
import { setSignUpPassword, setSignUpRePassword } from "../../../../../../../actions/form";
import { decrypt, encrypt } from "../../../utils/code";
import { CustomError } from "./CustomError";

const CustomPassword = (props) => {
  const {
    required,
    disabled,
    readonly,
    schema,
    uiSchema,
    onChange,
    idSchema,
    setSignUpPassword,
    setSignUpRePassword,
    password,
    rePassword,
    isRepassword = false
  } = props;
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={"custom-password custom-field"}>
      {schema.title && <label htmlFor={idSchema.$id} className={"control-label"}>{schema.title}</label>}
      <div className={"custom-password__input"}>
        <input
          name={idSchema.$id}
          className={"form-control"}
          required={required}
          disabled={disabled}
          readOnly={readonly}
          maxLength={schema["maxLength"]}
          id={idSchema.$id}
          type={showPassword ? "text" : "password"}
          value={isRepassword ? rePassword : password}
          placeholder={uiSchema["ui:placeholder"]}
          onChange={(e) => {
            onChange(e.target.value);
            isRepassword ? setSignUpRePassword(e.target.value) : setSignUpPassword(e.target.value)
          }}
        />
        <button type={"button"} className={`custom-password__eye ${showPassword ? 'active' : ''}`} tabIndex={-1} onClick={() => setShowPassword(!showPassword)}/>
      </div>
      {uiSchema["ui:description"] && (<p className="extra-text">{uiSchema["ui:description"]}</p>)}
      <CustomError schema={schema} uiSchema={uiSchema}/>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    password: decrypt(state.formData.password),
    rePassword: decrypt(state.formData.rePassword)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSignUpPassword: (password) => {
      const encryptedPassword = encrypt(password);
      dispatch(setSignUpPassword(encryptedPassword));
    },
    setSignUpRePassword: (rePassword) => {
      const encryptedRePassword = encrypt(rePassword);
      dispatch(setSignUpRePassword(encryptedRePassword));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomPassword);

const CustomRePassword = (props) => <CustomPassword {...props} isRepassword={true}/>;

export const ConnectedCustomRePassword = connect(mapStateToProps, mapDispatchToProps)(CustomRePassword);
